/** Live checkout URL for Dance Class Ready. Shared by the buy buttons that link straight to checkout. */
export const CHECKOUT_URL =
  'https://never-plan-a-dance-class-from-scratch-again.impultienda.ar/checkout'
